module.exports = __webpack_public_path__ + "static/media/srm_logo.14ffb3dd.png";